module.exports = __webpack_public_path__ + "img/jobs.ba078474.png";